<template>
  <div>
    <div v-if="!loading">
      <div class="text-gray-600 mb-4" v-if="!error">
        <p class="text-gray-400 mb-1">recordCount: {{clickhouseData.recordCount}}</p>
        <p class="text-gray-400 mb-1">accountCount: {{clickhouseData.accountCount}}</p>
        <br>
        <hr>
        <br>
        <h3>Demo</h3>
        <br>
        <p class="text-gray-400 mb-1">recordCount: {{clickhouseData.demoRecordCount}}</p>
        <p class="text-gray-400 mb-1">accountCount: {{clickhouseData.demoAccountCount}}</p>
      </div>
      <div class="text-red-600" v-else>
        Ошибка
      </div>
    </div>
    <LoaderIcon v-else/>
  </div>
</template>

<script>
import LoaderIcon from "@/components/LoaderIcon.vue";

export default {
  name: 'LoggerStateBlock',
  components: {LoaderIcon},
  data() {
    return {
      clickhouseData: null,
      error: null,
      loading: true
    }
  },
  mounted() {
    this.loadData();
  },
  computed: {
    /*tokenExist: function () {
      return this.tgSettings?.id > 0;
    }*/
  },
  methods: {
    loadData: function () {
      console.log("clickhouse");
      let c = this;
      c.tgSettings = null;
      c.loading = true;
      c.error = false;
      this.axios.get('/api/admin/logger').then(function(response) {
        console.log(response.data);
        c.clickhouseData = response.data.data;
        c.loading = false;
      }).catch(function(err) {
        console.log(err.status);
        c.loading = false;
        c.error = true;
      });
    }
  }
}
</script>

<style scoped>

</style>